import BN from "bn.js";
import { Address, Cell, contractAddress, StateInit } from "ton";
import { SendTransactionRequest, TonConnectUI } from "@tonconnect/ui-react";
import { BANAN_TOOL, CREATE_TOKEN_FEE } from "consts";
import { toTonConnectAddress } from "./ton-connect-address";

const createValidUntil = () => Math.floor(Date.now() / 1000) + 5 * 60;

interface ContractDeployDetails {
  deployer: Address;
  value: BN;
  code: Cell;
  data: Cell;
  message?: Cell;
  dryRun?: boolean;
}

export class ContractDeployer {
  addressForContract(params: ContractDeployDetails) {
    return contractAddress({
      workchain: 0,
      initialData: params.data,
      initialCode: params.code,
    });
  }

  async deployContract(
    params: ContractDeployDetails,
    tonConnection: TonConnectUI,
  ): Promise<Address> {
    const _contractAddress = this.addressForContract(params);
    let cell = new Cell();
    new StateInit({ data: params.data, code: params.code }).writeTo(cell);
    if (!params.dryRun) {
      const account = tonConnection.account;
      if (!tonConnection.connected || !account) {
        throw new Error("请先连接钱包");
      }

      if (!Address.parse(account.address).equals(params.deployer)) {
        throw new Error("当前连接的钱包已发生变化，请重新提交");
      }

      const deployMessage: NonNullable<SendTransactionRequest["messages"]>[number] = {
        address: toTonConnectAddress(_contractAddress),
        amount: params.value.toString(),
        stateInit: cell.toBoc().toString("base64"),
      };

      if (params.message) {
        deployMessage.payload = params.message.toBoc().toString("base64");
      }

      const tx: SendTransactionRequest = {
        validUntil: createValidUntil(),
        from: account.address,
        network: account.chain,
        messages: [
          deployMessage,
          {
            address: BANAN_TOOL,
            amount: CREATE_TOKEN_FEE,
          },
        ],
      };
      await tonConnection.sendTransaction(tx);
    }

    return _contractAddress;
  }
}
